import { of } from 'rxjs';
import { Repository } from '@jbt/utils';

export class EffectsRepository extends Repository<any> {

    constructor() {

        super({
            id: 'EffectsRepository',
            fallbackKey: 'default'
        });

        this.addByMap({
            default : () => of({ type: 'VOID' })
        });
    }
}
